import Vue from 'vue'
import App from './App.vue'
import router from './router'
import iView from 'iview'
// import './registerServiceWorker'
import locale from 'iview/dist/locale/it-IT'
import VueI18n from 'vue-i18n'
import VueStash from 'vue-stash'
import VuePrintNB from 'vue-print-nb'
import lodash from 'lodash'
import inViewportDirective from 'vue-in-viewport-directive'
import vSelect from 'vue-select'
import vueSignature from "vue-signature"
import http from './http'
import store from './store'
import './theme.less';
import LocalDate from './components/LocalDate'
import LedgerSelect from './components/ledger-select'
import NumInput from './components/num-input'
import utils from './utils'
import VueGoogleCharts from 'vue-google-charts'

Vue.use(VueGoogleCharts)
Vue.use(vueSignature)
Vue.component('v-select', vSelect)
Vue.directive('in-viewport', inViewportDirective)
Vue.use(VueStash)
Vue.use(VuePrintNB)
Vue.use(VueI18n)
Vue.use(iView, { locale })
Vue.use(http)

import wysiwyg from "vue-wysiwyg";
Vue.use(wysiwyg, {
  hideModules: { "image": true },
}); // config is optional. more below

Date.prototype.serializeUTC = Date.prototype.toServer = function() {
  return '' + this.getUTCFullYear() + "-" + utils.twoDigits(1 + this.getUTCMonth()) + "-" + utils.twoDigits(this.getUTCDate())
}
Date.prototype.serializeLocal = function() {
  return '' + this.getFullYear() + "-" + utils.twoDigits(1 + this.getMonth()) + "-" + utils.twoDigits(this.getDate())
}
Date.maintain = function(local) {
  if (!local) return null
  var q = local.split('-')
  return new Date(q[0], q[1]-1, q[2])
}
Date.fromUTC = function(local) {
  return new Date(local+' UTC')
}
Date.today = function() {
  return (new Date).serializeLocal()
}

// from http://twitter.com/WebReflection/status/83867362490720258
Array.prototype.unique = function() {
  function onlyUnique(value, index, self) {
      return self.indexOf(value) === index;
  }
  return this.filter(onlyUnique)
}



Vue.component('LocalDate', LocalDate)
Vue.component('LedgerSelect', LedgerSelect)
Vue.component('NumInput', NumInput)

Vue.config.productionTip = false
Vue.prototype._ = lodash
window._ = lodash
Vue.prototype.autofilter = (v, o) => !v || o.toUpperCase().indexOf(v.toUpperCase()) !== -1
Vue.prototype.req = {required:true, message: 'Campo richiesto'}
Vue.prototype.reqlt0 = { required: true, validator(rule, val, cb) {
  cb(val*1 > 0 ? undefined : new Error())
}, message: 'Il valore deve essere positivo'}

const i18n = new VueI18n({
  locale: 'it',
  numberFormats: {
    it: {
      currency: {
        style: 'currency', currency: 'EUR', currencyDisplay: 'symbol'
      }
    }
  },
  dateTimeFormats: {
    it: {
      justmonth: {
        month: 'long'
      },
      month: {
        year: 'numeric', month: 'long'
      },
      date: {
        day: 'numeric', month: 'long', year: 'numeric',
      },
    }
  },
})

Vue.prototype.$utils = utils

new Vue({
  router,
  render: h => h(App),
  i18n,
  data: { store }
}).$mount('#app')
